export default {
  text: 'Überspringen',
};
